import { Component, effect, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { QuizQuestionFacade } from '@app/store/quiz-question';
import { UnavailableComponent } from '@shared/components';
import { DeleteButtonComponent } from './delete-button/delete-button.component';

@Component({
    selector: 'app-quiz-question-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [TranslateModule, ButtonModule, BadgeModule, DeleteButtonComponent, UnavailableComponent],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly quizQuestionFacade = inject(QuizQuestionFacade);

    private readonly id = this.route.parent?.snapshot.params['id'];
    readonly quizQuestion = this.quizQuestionFacade.quizQuestion(this.id);
    readonly loading = this.quizQuestionFacade.loading(this.id);
    readonly error = this.quizQuestionFacade.error(this.id);
    readonly saving = this.quizQuestionFacade.saving;

    constructor() {
        if (this.id) {
            this.quizQuestionFacade.getQuizQuestion(this.id);
        }

        effect(() => {
            if (this.quizQuestionFacade.saved()) {
                this.close({ replaceUrl: !this.quizQuestion() });
            }
        });
    }

    ngOnDestroy(): void {
        this.quizQuestionFacade.clear();
    }

    onEdit(): void {
        const quizQuestion = this.quizQuestion();
        if (quizQuestion) {
            this.router.navigate([{ outlets: { modal: ['quiz-questions', 'edit', quizQuestion.id] } }]);
        }
    }

    close({ replaceUrl } = { replaceUrl: false }): void {
        this.router.navigate([{ outlets: { modal: null } }], { replaceUrl });
    }
}
